import { CommonData } from '../common_schema'

export const rocksdbRaftData: CommonData[] = [
  {
    name: 'Compaction operations(summary for all types)',
    mean: 'raft_Compaction_operations:total.values.mean',
    std: 'raft_Compaction_operations:total.values.std',
    location: 'TiKV-Details  --> RocksDB raft  --> Compaction operations'
  },
  {
    name: 'Compaction Flow(sum for read+written+flush)',
    mean: 'raft_Compaction_flows:total.values.mean',
    std: 'raft_Compaction_flows:total.values.std',
    location: 'TiKV-Details  --> RocksDB raft --> Compaction Flow'
  },
  {
    name: 'Compaction pending bytes(total)',
    mean: 'raft_Compaction_pending_bytes:total.values.mean',
    std: 'raft_Compaction_pending_bytes:total.values.std',
    location: 'TiKV-Details  --> RocksDB raft --> Compaction pending bytes'
  },
  {
    name: 'Write Stall duration',
    mean: 'raft_write_stall_duration:total.values.mean',
    std: 'raft_write_stall_duration:total.values.std',
    location: 'TiKV-Details  --> RocksDB raft --> Write Stall duration'
  },
  {
    name: 'Write Stall reason(summary for all reasons)',
    mean: 'raft_write_stall_reason:total.values.mean',
    std: 'raft_write_stall_reason:total.values.std',
    location: 'TiKV-Details  --> RocksDB raft --> Write Stall reason'
  },
  {
    name: `Impact to top level's Duration and QPS?`,
    mean: '[manual]',
    std: '[manual]',
    location: '[manual]'
  }
]
